import React from 'react';
import { Brightness4 as DarkModeIcon, Brightness7 as LightModeIcon } from '@mui/icons-material';

import { useThemeContext } from '../../context/ThemeContext';
import { useTranslation } from '../../context/TranslationContext';

import {
  HeaderPillButton,
  HeaderToggleRow,
  HeaderRowLabelGroup,
  HeaderRowLabel,
  HeaderRowSwitch,
  headerRowIconSx,
} from './styles';

const DarkModeToggle = ({ variant = 'pill', sx }) => {
  const { themeMode, toggleTheme } = useThemeContext();
  const { translate } = useTranslation();
  const switchTheme = () => {
    const newThemeMode = themeMode === 'dark' ? 'light' : 'dark';
    toggleTheme(newThemeMode);
  };
  const Icon = themeMode === 'dark' ? LightModeIcon : DarkModeIcon;
  const stateLabel = translate(themeMode === 'dark' ? 'header.Dark' : 'header.Light');

  if (variant === 'row') {
    const isDark = themeMode === 'dark';

    return (
      <HeaderToggleRow component="label" sx={sx}>
        <HeaderRowLabelGroup>
          <Icon sx={headerRowIconSx} />
          <HeaderRowLabel>{translate('header.Theme')}</HeaderRowLabel>
        </HeaderRowLabelGroup>
        <HeaderRowSwitch
          checked={isDark}
          onChange={switchTheme}
          slotProps={{
            input: {
              'aria-label': `${translate('header.Theme')} ${stateLabel}`,
            },
          }}
          disableRipple
        />
      </HeaderToggleRow>
    );
  }

  return (
    <HeaderPillButton
      type="button"
      aria-label={`${stateLabel} ${translate('header.Theme')}`}
      onClick={switchTheme}
      startIcon={<Icon />}
      sx={sx}
    >
      {stateLabel}
    </HeaderPillButton>
  );
};

export default DarkModeToggle;
